import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { BlockMobile as Block } from '@alfa-bank/site-block/mobile';
import { TextMobile as Text } from '@alfa-bank/site-text-v2/mobile';
import { Grid } from '@alfa-bank/site-grid-universal';
import { Link } from '@alfa-bank/site-link';
import { translateISODateToString } from '@alfa-bank/site-invest-common/helpers/date/translate-iso-date-to-string';
import { createPageUrl } from '@alfa-bank/site-invest-mediaportal-common/helpers';
import { FontStyrene } from '@alfa-bank/site-font-styrene';

import type { IArticleProps } from '../../model';
import { sendClickCardAnalytics } from '../../../../helpers/analytics';

import styles from './styles.css';

export const ArticleListMobile: FC<IArticleProps> = ({
    analytics,
    articles,
    baseUrlToArticle,
    dataTestId,
}) => {
    return (
        <div className={cn(styles.external, styles.wrapper)}>
            {articles.map(item => {
                return (
                    <Link
                        key={item.path}
                        className={cn(styles.external, styles.link)}
                        dataTestId={dataTestId}
                        href={createPageUrl(baseUrlToArticle, item.path)}
                        noUnderline
                        onClick={() => sendClickCardAnalytics(item, analytics)}
                    >
                        <Block
                            className={cn(styles.external, styles.block)}
                            notPadded
                            styler={{ paddingTop: 16, paddingBottom: 12 }}
                        >
                            <Grid
                                className={cn(styles.external, styles.grid)}
                                collapse
                                flexDirection="column"
                                justify="between"
                            >
                                <Text
                                    kind="secondary"
                                    styler={{ margin: 0 }}
                                    view="action-primary-small"
                                >
                                    {item.category.description}
                                    &nbsp;&bull;&nbsp;
                                    {translateISODateToString(item.publicationDate, {
                                        convertToMoscowDate: true,
                                    })}
                                </Text>
                                <Block notPadded styler={{ marginTop: 8 }}>
                                    <FontStyrene>
                                        <Text styler={{ margin: 0 }} view="accent-primary-medium">
                                            {item.title}
                                        </Text>
                                    </FontStyrene>
                                </Block>
                            </Grid>
                        </Block>
                    </Link>
                );
            })}
        </div>
    );
};
